import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import './assets/scss/themes.scss';
import RouteIndex from './core/routing/routes/Index';
import CustomToast from './core/components/common/CustomToast';
import HardReloadButton from './core/components/common/HardReloadButton';
import { AuthProvider } from './core/contexts/AuthContext';
import { TimezoneProvider } from './core/contexts/TimezoneContext';

// Keeps the browser tab title/favicon in sync with the active org's branding.
// document.title only ever binds to the first <title> in the document, so
// setting it here is safe regardless of what public/index.html contains.
function BrandingSync() {
  const branding = useSelector((state: any) => state.Profile?.branding || null);

  useEffect(() => {
    if (branding?.org_name) {
      document.title = branding.org_name;
    }
    if (branding?.favicon) {
      let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = branding.favicon;
    }
  }, [branding]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <TimezoneProvider>
        <BrandingSync />
        <HardReloadButton />
        <CustomToast />
        <RouteIndex />
      </TimezoneProvider>
    </AuthProvider>
  );
}

export default App;

